import { defineComponent } from "vue";
import { saveEnvironment, updateEnvironment, loadEnvironment, deleteEnvironment } from "@/store/environment/actions";
import { SdkEnvironment, SdkOptions, SdkTransfer } from "@/interfaces/sdk-environment";
import { loadAllSystem } from "@/store/system/actions";
import { SdkSystem } from "@/interfaces/sdk-system";
import { loadAllCompany } from "@/store/company/actions";
import { SdkCompany } from "@/interfaces/sdk-company";
import { INotification, ETypeNotification } from "@/interfaces/i-notification";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "sdk-forms-environment-single",
  data() {
    return {
      loading: false,
      formData: { name: "", type: "", company: { name: "", id: undefined, cnpj: "" } } as SdkEnvironment,
      newRecord: false,
      companies: [] as SdkCompany[],
      environments: [] as SdkEnvironment[],
      valueSys: [] as number[],
      notification: [] as INotification[],
      optionsType: [
        {
          value: "PRODUCTION",
          label: "PRODUCTION",
        },
        {
          value: "TRAINING",
          label: "TRAINING",
        },
        {
          value: "HOMOLOGATION",
          label: "HOMOLOGATION",
        },
        {
          value: "CUSTOMIZED",
          label: "CUSTOMIZED",
        },
      ] as SdkOptions[],
      dataSys: [] as any[],
    };
  },
  computed: {
    isFormFilled(): boolean {
      return this.formData.name !== "" && this.formData.company!.id !== undefined;
    },
  },
  methods: {
    async fetchEnvironment() {
      this.formData = { name: "", company: { name: "", id: undefined, cnpj: "" } } as SdkEnvironment;
      this.valueSys = [];
      const { environment } = this.$route.params;
      if (environment === "new") {
        this.formData = { name: "", company: { name: "", id: undefined, cnpj: "" } } as SdkEnvironment;
        this.newRecord = true;
      } else {
        await this.$dispatch(loadEnvironment)([this.$route.params.environment]).then((data: SdkEnvironment) => {
          this.formData = data;
          const systemsLength = this.formData.systems!.length;
          if (systemsLength > 0) {
            this.valueSys = [];
            for (let i = 0; i <= systemsLength; i++) {
              if (this.formData.systems![i]) {
                this.valueSys.push(this.formData.systems![i].id as number);
              }
            }
          }
        });
      }
    },
    async fetchCompanies() {
      this.$dispatch(loadAllCompany)().then((data: SdkCompany[]) => {
        this.companies = data;
      });
    },
    async update() {
      if (this.formData.name !== "") {
        const env: any = { ...this.formData };
        env.systems = [];
        this.valueSys.forEach((sys: any) => {
          env.systems.push({ id: sys });
        });
        await this.$dispatch(updateEnvironment)([env], this.$t("forms.environmentsItem.notifications.update.success")).then(() => this.endCreation());
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.environmentsItem.notifications.error.warning") as string,
          message: this.$t("forms.environmentsItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async save() {
      if (this.formData.name !== "") {
        const env: any = { ...this.formData };
        env.systems = [];
        this.valueSys.forEach((sys: any) => {
          env.systems.push({ id: sys });
        });
        await this.$dispatch(saveEnvironment)([env], this.$t("forms.environmentsItem.notifications.save.success")).then(() => this.endCreation());
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.environmentsItem.notifications.error.warning") as string,
          message: this.$t("forms.environmentsItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async del() {
      await this.$dispatch(deleteEnvironment)([this.$route.params.environment], this.$t("forms.environmentsItem.notifications.delete.success")).then(
        () => this.endCreation()
      );
    },
    generateData() {
      const data: SdkTransfer[] = [];
      this.$dispatch(loadAllSystem)().then((dataSys: SdkSystem[]) => {
        for (let i = 0; i <= dataSys.length; i++) {
          if (dataSys[i]) {
            data.push({
              key: dataSys[i].id || 0,
              label: `${dataSys[i].name} ${dataSys[i].version}`,
            });
          }
        }
      });
      this.dataSys = data;
      return data;
    },
    endCreation() {
      this.$router.push({ name: "environments" });
    },
  },
  async mounted() {
    this.generateData();
    this.fetchCompanies();
    this.fetchEnvironment();
  },
});
